<template>
    <article>
        <ContentHero
            :background-color="entry?.contentHero?.[0]?.backgroundColor"
            :image-position="entry?.contentHero?.[0]?.imagePosition || 'topLeft'"
            :image="entry?.contentHero?.[0]?.image?.[0]"
            :video-mp4="entry?.contentHero?.[0]?.videoMp4?.[0]"
            :video-web-m="entry?.contentHero?.[0]?.videoWebM?.[0]"
            :pending="pending"
        >
            <template #title>{{ entry?.title }}</template>
            <template #description>{{ entry?.contentHero?.[0]?.description }}</template>
            <template #caption>{{ entry?.contentHero?.[0]?.caption }}</template>
        </ContentHero>

        <TheBookingForm v-if="entry?.showBookingForm" />

        <VizyBlocksContentBuilder
            :pending="pending"
            :nodes="entry?.contentBuilder?.nodes"
        />

        <BaseSection
            v-if="entry?.showContactForm"
            :background-color="entry?.contactForm?.[0]?.backgroundColor"
            :pending="pending"
            :class="!entry?.contentBuilder?.nodes?.length ? 'base-section--less-padding base-section--align-left' : 'base-section--split'"
        >
            <template
                v-if="entry?.contactForm?.[0]?.title "
                #title
            >
                {{ entry?.contactForm?.[0]?.title }}
            </template>

            <template
                #intro
            >
                {{ entry?.contactForm?.[0]?.description }}
                At the July stories are at the centre of what we do, check into your next chapter
            </template>

            <LazyContactForm />
        </BaseSection>

        <NewsletterBlock
            v-if="entry?.showNewsletter && entry?.newsletterBlock?.[0]"
            :image="entry?.newsletterBlock?.[0].image?.[0]"
            :pending="pending"
            :background-color="entry?.newsletterBlock?.[0]?.backgroundColor"
            :list-id="entry?.newsletterBlock?.[0]?.listId ?? undefined"
            :consent-id="entry?.newsletterBlock?.[0]?.consentId ?? undefined"
        >
            <template
                v-if="entry?.newsletterBlock?.[0]?.title"
                #title
            >
                {{ entry?.newsletterBlock[0]?.title }}
            </template>

            <template
                v-if="entry?.newsletterBlock[0]?.description"
                #description
            >
                {{ entry?.newsletterBlock[0]?.description }}
            </template>
        </NewsletterBlock>

        <LazyRelatedItems
            v-if="entry?.showRelatedItems && entry?.relatedItems.length > 0"
            :background-color="entry?.relatedItems?.[0]?.backgroundColor"
            :items="entry?.relatedItems?.[0]?.entries"
            :pending="pending"
        >
            <template
                v-if="entry?.relatedItems?.[0]?.title"
                #title
            >
                {{ entry?.relatedItems?.[0]?.title }}
            </template>
            <template
                v-if=" entry?.relatedItems?.[0]?.caption"
                #caption
            >
                {{ entry?.relatedItems?.[0]?.caption }}
            </template>
        </LazyRelatedItems>
    </article>
</template>

<script setup>
import PageQuery from '~/graphql/queries/page.graphql';

const { variables } = useCraftGraphql();
const response = await useLazyAsyncQuery({
    query: PageQuery,
    variables
});

const pending = response?.pending;
const { craftEntry: entry } = useCraftPage(response);
</script>
